import React, { Fragment } from 'react'
import {processText} from './component-helpers/utilfunctions'

const BodyText =(props) => {
  let {type, className, text} = props

  if(!className) {
    className=""
  }

  if(!type) {
    type="serif"
  }

  const object = {...props}
  delete object["text"]
  delete object["type"]

  return (
    <div className="body-text-container" {...object} dangerouslySetInnerHTML={{__html: processText(text, type+"-copy")}} />
  )
}

export default BodyText
